import {createContext, SetStateAction, useContext} from "react";

export interface QuanLyNhanSuContextProps {
  dsNhanSu: any;
  setDsNhanSu: SetStateAction<any>;
  detailNhanSu: any;
  setDetailNhanSu: SetStateAction<any>;

}

const initialContext = {
  dsNhanSu: [],
  setDsNhanSu: () => { },
  detailNhanSu: [],
  setDetailNhanSu: () => { },
}

export const QuanLyNhanSuContext = createContext<QuanLyNhanSuContextProps>(initialContext);

export const useQuanLyNhanSuContext = () => useContext(QuanLyNhanSuContext);

export const QuanLyNhanSuProvider = QuanLyNhanSuContext.Provider;
